import {
  GET_PRODUCT_REQ,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_ERROR,
  GET_CATEGORIES_REQ,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  UPDATE_SHIPPINGCOST_REQ,
  UPDATE_SHIPPINGCOST_SUCCESS,
  UPDATE_SHIPPINGCOST_ERROR,
  GET_SHIPPINGCOST_REQ,
  GET_SHIPPINGCOST_SUCCESS,
  GET_SHIPPINGCOST_ERROR,
  UPDATE_PRODUCT_REQ,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_ERROR,
  POST_PRODUCT_REQ,
  POST_PRODUCT_SUCCESS,
  POST_PRODUCT_ERROR,
  POST_CUSTOMPRODUCT_REQ,
  POST_CUSTOMPRODUCT_SUCCESS,
  POST_CUSTOMPRODUCT_ERROR,
  GET_BASEMIX_CATEGORIES_REQ,
  GET_BASEMIX_CATEGORIES_SUCCESS,
  GET_BASEMIX_CATEGORIES_ERROR,
  GET_BASEMIXES_REQ,
  GET_BASEMIXES_SUCCESS,
  GET_BASEMIXES_ERROR,
  GET_ADDITIVES_REQ,
  GET_ADDITIVES_SUCCESS,
  GET_ADDITIVES_ERROR,
  GET_BASEMIXES_CATEGORIES_REQ,
  GET_BASEMIXES_CATEGORIES_SUCCESS,
  GET_BASEMIXES_CATEGORIES_ERROR,
  POST_BASEMIX_REQ,
  POST_BASEMIX_SUCCESS,
  POST_BASEMIX_ERROR,
  GET_TEMPLATE_REQ,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_ERROR,
  POST_FILE_REQ,
  POST_FILE_SUCCESS,
  POST_FILE_ERROR,
  POST_SHIPPINGCOST_REQ,
  POST_SHIPPINGCOST_SUCCESS,
  POST_SHIPPINGCOST_ERROR,
} from "../constants";

export default class CatalogAction {
  static getCategoriesReq(params) {
    return {
      type: GET_CATEGORIES_REQ,
      params,
    };
  }

  static getCategoriesSuccess(payload) {
    return {
      type: GET_CATEGORIES_SUCCESS,
      payload,
    };
  }
  static getCategoriesError(error) {
    return {
      type: GET_CATEGORIES_ERROR,
      error,
    };
  }
  static getProductReq(params, isTrue) {
    return {
      type: GET_PRODUCT_REQ,
      params,
      isTrue,
    };
  }
  static getProductSuccess(payload, metaData) {
    return {
      type: GET_PRODUCT_SUCCESS,
      payload,
      metaData,
    };
  }
  static getProductError(error) {
    return {
      type: GET_PRODUCT_ERROR,
      error,
    };
  }
  static getShipingCostReq(params) {
    return {
      type: GET_SHIPPINGCOST_REQ,
      params,
    };
  }

  static getShipingCostSuccess(payload) {
    return {
      type: GET_SHIPPINGCOST_SUCCESS,
      payload,
    };
  }
  static getShipingCostError(error) {
    return {
      type: GET_SHIPPINGCOST_ERROR,
      error,
    };
  }

  static postShippingCostReq(payload) {
    return {
      type: POST_SHIPPINGCOST_REQ,
      payload,
    };
  }
  static postShippingCostSuccess(res) {
    return {
      type: POST_SHIPPINGCOST_SUCCESS,
      res,
    };
  }
  static postShippingCostFailure(error) {
    return {
      type: POST_SHIPPINGCOST_ERROR,
      error,
    };
  }
  static updateShipingCostReq(params, id) {
    return {
      type: UPDATE_SHIPPINGCOST_REQ,
      params,
      id,
    };
  }
  static updateShipingCostSuccess(payload) {
    return {
      type: UPDATE_SHIPPINGCOST_SUCCESS,
      payload,
    };
  }
  static updateShipingCostError(error) {
    return {
      type: UPDATE_SHIPPINGCOST_ERROR,
      error,
    };
  }
  static updateProductReq(params, id, activestatus, cb) {
    return {
      type: UPDATE_PRODUCT_REQ,
      params,
      id,
      activestatus,
      cb,
    };
  }

  static updateProductSuccess(payload) {
    return {
      type: UPDATE_PRODUCT_SUCCESS,
      payload,
    };
  }
  static updateProductError(error) {
    return {
      type: UPDATE_PRODUCT_ERROR,
      error,
    };
  }

  static postProductReq(payload, cb, isTrue) {
    return {
      type: POST_PRODUCT_REQ,
      payload,
      cb,
      isTrue,
    };
  }

  static postProductSuccess(payload) {
    return {
      type: POST_PRODUCT_SUCCESS,
      payload,
    };
  }
  static postProductError(error) {
    return {
      type: POST_PRODUCT_ERROR,
      error,
    };
  }

  static postCustomProductReq(payload, cb) {
    return {
      type: POST_CUSTOMPRODUCT_REQ,
      payload,
      cb,
    };
  }

  static postCustomProductSuccess(payload) {
    return {
      type: POST_CUSTOMPRODUCT_SUCCESS,
      payload,
    };
  }
  static postCustomProductError(error) {
    return {
      type: POST_CUSTOMPRODUCT_ERROR,
      error,
    };
  }
  static getBasemixCategoriesReq(params) {
    return {
      type: GET_BASEMIX_CATEGORIES_REQ,
      params,
    };
  }
  static getBasemixCategoriesSuccess(payload) {
    return {
      type: GET_BASEMIX_CATEGORIES_SUCCESS,
      payload,
    };
  }
  static getBasemixCategoriesError(error) {
    return {
      type: GET_BASEMIX_CATEGORIES_ERROR,
      error,
    };
  }

  static getBasemixesReq(params) {
    return {
      type: GET_BASEMIXES_REQ,
      params,
    };
  }
  static getBasemixesSuccess(payload) {
    return {
      type: GET_BASEMIXES_SUCCESS,
      payload,
    };
  }
  static getBasemixesError(error) {
    return {
      type: GET_BASEMIXES_ERROR,
      error,
    };
  }

  static getAdditivesReq(params) {
    return {
      type: GET_ADDITIVES_REQ,
      params,
    };
  }
  static getAdditivesSuccess(payload) {
    return {
      type: GET_ADDITIVES_SUCCESS,
      payload,
    };
  }
  static getAdditivesError(error) {
    return {
      type: GET_ADDITIVES_ERROR,
      error,
    };
  }

  static getBasemixesCategoriesReq(params) {
    return {
      type: GET_BASEMIXES_CATEGORIES_REQ,
      params,
    };
  }
  static getBasemixesCategoriesSuccess(payload) {
    return {
      type: GET_BASEMIXES_CATEGORIES_SUCCESS,
      payload,
    };
  }
  static getBasemixesCategoriesError(error) {
    return {
      type: GET_BASEMIXES_CATEGORIES_ERROR,
      error,
    };
  }
  static postBasemixReq(payload, urlParams, cb) {
    return {
      type: POST_BASEMIX_REQ,
      payload,
      urlParams,
      cb,
    };
  }
  static postBasemixSuccess(payload) {
    return {
      type: POST_BASEMIX_SUCCESS,
      payload,
    };
  }
  static postBasemixError(error) {
    return {
      type: POST_BASEMIX_ERROR,
      error,
    };
  }

  static getTemplateReq(params) {
    return {
      type: GET_TEMPLATE_REQ,
      params,
    };
  }
  static getTemplateSuccess(payload) {
    return {
      type: GET_TEMPLATE_SUCCESS,
      payload,
    };
  }
  static getTemplateError(error) {
    return {
      type: GET_TEMPLATE_ERROR,
      error,
    };
  }

  static postFileReq(payload) {
    return {
      type: POST_FILE_REQ,
      payload,
    };
  }
  static postFileSuccess(payload) {
    return {
      type: POST_FILE_SUCCESS,
      payload,
    };
  }
  static postFileError(error) {
    return {
      type: POST_FILE_ERROR,
      error,
    };
  }
}
